var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCellFieldProductBasic',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"previewDialog",fn:function(ref){
var selectedColumnOrder = ref.selectedColumnOrder;
var selectedRefFields = ref.selectedRefFields;
var dialog = ref.dialog;
var manageDialog = ref.manageDialog;
var selectRefFields = ref.selectRefFields;
return [_c('ProductCellFieldProductReferenceAdding',{attrs:{"items":selectedColumnOrder,"selected":selectedRefFields,"dialog":dialog},on:{"manageDialog":manageDialog,"selectFields":selectRefFields}})]}}])},'ProductCellFieldProductBasic',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }